import { post } from '../../../../infra/rest';
import { ShopifyShopStatus } from '../../../shopify/v1/typings';

const shopifyStoreInstall = async (shopId: string) => {
  return post<{ status: ShopifyShopStatus }>(
    `/v1/shopify/authorize-store-install/${shopId}`,
    {},
    true
  );
};

export default shopifyStoreInstall;
